<template>
  <!-- <base-page> -->
  <DevizProduse   ref="deviz_produse" />
  <!-- </base-page> -->
</template>

<script>
import settings from "@/backend/LocalSettings";
// import BasePage from "@/pages/Admin/BasePage";
import DevizProduse from '@/components/Programare_produse';

export default {
  name: "masini",
  // extends: BasePage,
  components: {
    // "base-page": BasePage,
    DevizProduse,
  },
  data() {
    return {
     
    };
  },
  methods: {

  },
  mounted() {
    // if (this.$has_right('Mecanic') ){
    //   this.$router.push('/no-rights')
    //   return
    // }
  },
};
</script>

<style lang="less" scoped>

</style>
